import React from "react";
//export const BASE_URL = "https://localhost:7247"
export const BASE_URL = "https://api.itsolb.com"

export const LOGIN = "/api/Auth/login"; // POST
export const REFRESH_TOKEN = "/api/Auth/refresh-token"; // POST

export const PLANS = "/api/plans"; // GET
export const Admin = "/api/admin"; // GET
export const SERVICES = "/api/services"; // GET
export const SUBSCRIPTION = "/api/Subscriptions"; // GET
export const NOTIFICATIONS = "/api/notifications"; // GET
export const CLIENTS = "/api/clients"; // GET
export const RESELLERS = "/api/resellers"; // GET
